import { baseRequest } from '.'
import _get from 'lodash/get'
import { invitationAdapter } from './adapters'

export const cancelInvitation = async invitationId => {
  const res = await baseRequest.delete(`invitation/${invitationId}/cancel`)
  return res
}

export const resendInvitation = async invitationId => {
  return await baseRequest.post(`invitation/${invitationId}/resend`)
}

export const getEventInvitations = async (
  event_id,
  search_query,
  page,
  limit,
  optionSortBy,
  optionSortOrder,
  timezone,
  filterBy = [],
) => {
  const res = await baseRequest.get(`events/${event_id}/relationships/invitations/`, {
    params: {
      search_query,
      page,
      limit,
      'options[sort_by]': optionSortBy,
      'options[sort_order]': optionSortOrder,
      'options[filter_by]': filterBy,
    },
    paramsSerializer: data => {
      return Object.keys(data)
        .map(key => {
          if (key === 'options[filter_by]') {
            return typeof data[key] === 'object'
              ? Object.keys(data[key]).map(
                  column =>
                    `&${key}[${column}][]=` +
                    (Array.isArray(data[key][column])
                      ? data[key][column].join(`&${key}[${column}][]=`)
                      : data[key][column]),
                )
              : `&${key}[]=`
          } else {
            return `${key}=${data[key] ?? ''}`
          }
        })
        .join('&')
    },
  })
  const data = _get(res, 'data.data.data')
  return invitationAdapter(data, timezone)
}

export const getEventLinkInvitations = async event_id => {
  const res = await baseRequest.get(`/${event_id}/get-invitations`)
  const data = _get(res, 'data.data')
  return data
}